import { render } from "./add-invoice.vue?vue&type=template&id=27640f24"
import script from "./add-invoice.vue?vue&type=script&lang=js"
export * from "./add-invoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__